const BADGE_CLASS = 'js-free-shipping-badge';

// Keep in sync with snippets/mx-cart-fee-total.liquid — order fees (Balné) are
// left out of the cart total the same way the cart and header do it, otherwise
// the badge would promise free shipping a little too early.
const ORDER_FEE_PRODUCT_TYPE = 'Fee Placeholder';

if (!customElements.get('free-shipping-badge')) {
  class FreeShippingBadge extends HTMLElement {
    constructor() {
      super();

      this.minimum = null;
      this.cartTotal = 0;

      this.headerEl = document.querySelector('#header-free-shipping .header__free-shipping-text');
      this.productPrice = document.querySelector('.product-info__price .js-price');
      this.pdpContainer = document.querySelector('.product-info variant-label .product-label-container') || document.querySelector('.product-info .product-label-container') || document.querySelector('variant-label');

      document.addEventListener('on:cart:add', this.fetchCartAndUpdate.bind(this));
      document.addEventListener('on:line-item:change', this.fetchCartAndUpdate.bind(this));
      document.addEventListener('on:boost:card:update', (evt) => this.processBoostCard(evt));

      this.init();
    }

    init() {
      this.config = window.freeShippingBadgeConfig;

      if (!this.config) {
        return;
      }

      // The minimum (in cents) is emitted by snippets/mx-header-free-shipping-text.liquid.
      const minimum = this.headerEl ? parseInt(this.headerEl.dataset.minimum, 10) : NaN;
      if (Number.isNaN(minimum)) {
        return;
      }
      this.minimum = minimum;

      this.fetchCartAndUpdate();
    }

    async fetchCartAndUpdate() {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      this.cartTotal = this.totalWithoutFees(cart);

      if (this.pdpContainer) {
        const variantPrice = this.getPDPVariantPrice();
        this.processPDP(variantPrice);
      }
    }

    /**
     * Helper methods
     */
    totalWithoutFees(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      return cart.items.reduce((sum, item) => {
        if (item.product_type === ORDER_FEE_PRODUCT_TYPE) return sum;
        return sum + item.final_line_price;
      }, 0);
    }

    createBadgeHTML() {
      return `
        <div class="product-label-wrapper flex ${BADGE_CLASS}">
          <span class="product-label" style="background-color: ${this.config.bgColor}; color: ${this.config.textColor};">
            ${this.config.text}
          </span>
        </div>
      `;
    }

    processBoostCard(evt) {
      const cardId = evt.detail.productId;
      const card = document.querySelector(`[data-product-id="${cardId}"]`);
      if (!card) return;

      const placeholder = card.querySelector('.mx-product-badges-placeholder');
      if (!placeholder) return;
  
      const price = this.getBoostCardPrice(card);
      this.removeBadge(placeholder);
  
      if (price > 0 && this.shouldShowBadge(price) && !this.isOversize(placeholder)) {
        placeholder.insertAdjacentHTML('beforeend', this.createBadgeHTML());
        placeholder.removeAttribute('hidden');
      }
    }

    processPDP(variantPrice) {
      if (!this.pdpContainer) return;

      this.removeBadge(this.pdpContainer);
  
      if (variantPrice > 0 && this.shouldShowBadge(variantPrice) && !this.isOversize(this.pdpContainer)) {
        this.pdpContainer.insertAdjacentHTML('beforeend', this.createBadgeHTML());
      }
    }

    removeBadge(container) {
      const existing = container.querySelector(`.${BADGE_CLASS}`);
      if (existing) existing.parentNode.removeChild(existing);
    }
    
    // TIPA: nadrozměr (Fofr) nemá dopravu zdarma. Značku data-tipa-nadrozmer dává
    // snippets/product-label.liquid na kontejner štítků.
    isOversize(scope) {
      if (!scope) return false;
      return scope.matches('[data-tipa-nadrozmer]') || !!scope.querySelector('[data-tipa-nadrozmer]');
    }

    shouldShowBadge(productPrice) {
      if (this.minimum === null) return false;
      return productPrice >= this.minimum;
      //return (this.cartTotal + productPrice) >= this.minimum; včetně košíku
    }

    getBoostCardPrice(card) {
      if (!card.dataset.product) return 0;

      try {
        const data = JSON.parse(card.dataset.product);
        // priceMin from Boost is in currency units, convert to cents to match cart/minimum
        const price = (Number(data.priceMin) || 0) * 100;
        return price;
      } catch (e) {
        return 0;
      }
    }

    getPDPVariantPrice() {
      if (!this.productPrice) return 0;
      return parseInt(this.productPrice.dataset.price, 10);
    }
  }

  customElements.define('free-shipping-badge', FreeShippingBadge);
}